import { useContext } from "react";
import { Map } from "../features/map/Map";
import { ToolsContext } from "../ToolsContext";
import { CalendarEditor } from "../features/calendars/CalendarEditor";
import { TimetableEditor } from "../features/timetables/TimetableEditor";
import { MapMl } from "../features/mapMl/MapMl";

export function MainPanel() {
    const tool = useContext(ToolsContext);

    if (tool.name === 'calendarsTool') return (<CalendarEditor GCalendar={tool.propertyEditor}></CalendarEditor>);
    if (tool.name === 'timetablesTool') return (<TimetableEditor routeId={tool.selection}></TimetableEditor>);

    return ( <MapMl /> );
    //return ( <MapOl/> );
    //return ( <Map/> );
}